// import React from 'react';
// import { MapPinIcon, BellIcon, UserCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

// const UserHeader = ({ userData }) => {
//     const navItems = [
//         { name: 'Current Location', icon: MapPinIcon },
//         { name: 'Activities', icon: null },
//         { name: 'Services', icon: null },
//         { name: 'Bookings', icon: null },
//         { name: 'Deals', icon: null },
//     ];

//     return (
//         <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//             <div className="container mx-auto flex items-center justify-between">
//                 {/* Logo */}
//                 <div className="flex-shrink-0">
//                     <img src="/upswap.png" alt="UpSway Logo" className="h-10" />
//                 </div>

//                 {/* Navigation Links */}
//                 <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//                     {navItems.map((item, index) => (
//                         <div key={index} className="relative group text-gray-700 hover:text-blue-600 cursor-pointer flex items-center text-sm font-medium">
//                             {item.icon && <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-blue-600" />}
//                             <span>{item.name}</span>
//                             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//                             <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//                                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Dropdown Item 1</a>
//                                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Dropdown Item 2</a>
//                             </div>
//                         </div>
//                     ))}
//                 </nav>

//                 {/* Right-side Icons */}
//                 <div className="flex items-center space-x-4 ml-auto">
//                     <div className="relative cursor-pointer text-gray-600 hover:text-blue-600">
//                         <BellIcon className="h-6 w-6" />
//                         <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//                     </div>

//                     <div className="relative group cursor-pointer text-gray-600 hover:text-blue-600 flex items-center">
//                         <UserCircleIcon className="h-7 w-7" />
//                         <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//                         <div className="absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//                             <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">My Profile</a>
//                             <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Settings</a>
//                             <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Logout</a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default UserHeader;

// src/components/Dashboard/UserHeader.jsx
// import React from "react";
// import {
//   MapPinIcon,
//   BellIcon,
//   UserCircleIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// // If you want to use logout here, you would import useAuth:
// // import { useAuth } from '../authentication/AuthContext';
// // import { useNavigate } from 'react-router-dom';

// const UserHeader = ({ userData }) => {
//   // const { logout } = useAuth(); // Uncomment if you add logout functionality
//   // const navigate = useNavigate(); // Uncomment if you add logout functionality

//   const navItems = [
//     { name: "Current Location", icon: MapPinIcon },
//     { name: "Activities", icon: null },
//     { name: "Services", icon: null },
//     { name: "Bookings", icon: null },
//     { name: "Deals", icon: null },
//   ];

//   // const handleLogout = () => { // Uncomment if you add logout functionality
//   //     logout();
//   //     navigate('/');
//   // };

//   return (
//     <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//       <div className="container mx-auto flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex-shrink-0">
//           {/* Ensure /upswap.png is in your public folder */}
//           <img src="/upswap.png" alt="UpSway Logo" className="h-10" />
//         </div>

//         {/* Navigation Links */}
//         <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//           {navItems.map((item, index) => (
//             <div
//               key={index}
//               className="relative group text-gray-700 hover:text-blue-600 cursor-pointer flex items-center text-sm font-medium"
//             >
//               {item.icon && (
//                 <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-blue-600" />
//               )}
//               <span>{item.name}</span>
//               <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//               <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//                 <a
//                   href="#"
//                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 >
//                   Dropdown Item 1
//                 </a>
//                 <a
//                   href="#"
//                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 >
//                   Dropdown Item 2
//                 </a>
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* Right-side Icons */}
//         <div className="flex items-center space-x-4 ml-auto">
//           <div className="relative cursor-pointer text-gray-600 hover:text-blue-600">
//             <BellIcon className="h-6 w-6" />
//             <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//           </div>

//           <div className="relative group cursor-pointer text-gray-600 hover:text-blue-600 flex items-center">
//             <UserCircleIcon className="h-7 w-7" />
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//             <div className="absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//               <a
//                 href="#"
//                 className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 My Profile
//               </a>
//               <a
//                 href="#"
//                 className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Settings
//               </a>
//               {/* <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Logout</button> */}
//               <a
//                 href="#"
//                 className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Logout
//               </a>{" "}
//               {/* Replace with button and handleLogout */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default UserHeader;

// src/components/Dashboard/UserHeader.jsx
// import React from 'react';
// import { MapPinIcon, BellIcon, UserCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
// // If you want to use logout here, you would import useAuth:
// import { useAuth } from '../Authentication/AuthContext'; // Corrected Path
// import { useNavigate } from 'react-router-dom';

// const UserHeader = ({ userData }) => {
//     const { logout } = useAuth(); // Uncommented for logout functionality
//     const navigate = useNavigate(); // Uncommented for logout functionality

//     const navItems = [
//         { name: 'Current Location', icon: MapPinIcon },
//         { name: 'Activities', icon: null },
//         { name: 'Services', icon: null },
//         { name: 'Bookings', icon: null },
//         { name: 'Deals', icon: null },
//     ];

//     const handleLogout = () => {
//         logout();
//         navigate('/'); // Redirect to home/public page after logout
//     };

//     return (
//         <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//             <div className="container mx-auto flex items-center justify-between">
//                 {/* Logo */}
//                 <div className="flex-shrink-0">
//                     <img src="/upswap.png" alt="UpSway Logo" className="h-10" />
//                 </div>

//                 {/* Navigation Links */}
//                 <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//                     {navItems.map((item, index) => (
//                         <div key={index} className="relative group text-gray-700 hover:text-blue-600 cursor-pointer flex items-center text-sm font-medium">
//                             {item.icon && <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-blue-600" />}
//                             <span>{item.name}</span>
//                             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//                             <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//                                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Dropdown Item 1</a>
//                                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Dropdown Item 2</a>
//                             </div>
//                         </div>
//                     ))}
//                 </nav>

//                 {/* Right-side Icons */}
//                 <div className="flex items-center space-x-4 ml-auto">
//                     <div className="relative cursor-pointer text-gray-600 hover:text-blue-600">
//                         <BellIcon className="h-6 w-6" />
//                         <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//                     </div>

//                     <div className="relative group cursor-pointer text-gray-600 hover:text-blue-600 flex items-center">
//                         <UserCircleIcon className="h-7 w-7" />
//                         <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400 group-hover:text-blue-600" />
//                         <div className="absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg hidden group-hover:block z-10">
//                             <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">My Profile</a>
//                             <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Settings</a>
//                             <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Logout</button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default UserHeader;

// src/components/Dashboard/UserHeader.jsx
// import React, { useState } from "react"; // Import useState
// import {
//   MapPinIcon,
//   BellIcon,
//   UserCircleIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// import { useAuth } from "../Authentication/AuthContext";
// import { useNavigate } from "react-router-dom";

// const UserHeader = ({ userData }) => {
//   const { logout } = useAuth();
//   const navigate = useNavigate();

//   // State to manage the visibility of the user dropdown
//   const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

//   const [openNavDropdown, setOpenNavDropdown] = useState(null); // Stores the index of the open dropdown

//   const navItems = [
//     {
//       name: "Current Location",
//       icon: MapPinIcon,
//       dropdownItems: ["Explore Locations", "Manage Addresses"],
//     },
//     {
//       name: "Activities",
//       icon: null,
//       dropdownItems: [
//         "Browse Activities",
//         "Create Activity",
//         "My Activities",
//         "Join Activities",
//       ],
//     },
//     {
//       name: "Services",
//       icon: null,
//       dropdownItems: ["Browse Services", "Saved Services", "Favorites"],
//     },
//     {
//       name: "Bookings",
//       icon: null,
//       dropdownItems: ["Upcoming", "History", "Appointments"],
//     },
//     {
//       name: "Deals",
//       icon: null,
//       dropdownItems: [
//         "Browse Deals",
//         "Saved Deals",
//         "Purchased Deals",
//         "Purchase History",
//       ],
//     },
//   ];

//   const handleLogout = () => {
//     logout();
//     navigate("/"); // Redirect to home/public page after logout
//   };

//   const handleUserDropdownToggle = () => {
//     setIsUserDropdownOpen(!isUserDropdownOpen);
//     setOpenNavDropdown(null); // Close any open navigation dropdown when user dropdown is toggled
//   };

//   const handleNavDropdownToggle = (index) => {
//     setOpenNavDropdown(openNavDropdown === index ? null : index); // Toggle specific nav dropdown
//     setIsUserDropdownOpen(false); // Close user dropdown when a nav dropdown is toggled
//   };

//   // Close dropdowns when clicking outside
//   // This useEffect will listen for clicks on the document
//   // and close any open dropdowns if the click is outside.
//   React.useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Check if the click is outside the user dropdown
//       if (
//         isUserDropdownOpen &&
//         !event.target.closest(".user-dropdown-container")
//       ) {
//         setIsUserDropdownOpen(false);
//       }
//       // Check if the click is outside any nav dropdown
//       if (
//         openNavDropdown !== null &&
//         !event.target.closest(".nav-dropdown-container")
//       ) {
//         setOpenNavDropdown(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isUserDropdownOpen, openNavDropdown]);

//   return (
//     <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//       <div className="container mx-auto flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex-shrink-0">
//           <img src="/upswap.png" alt="UpSway Logo" className="h-10" />
//         </div>

//         {/* Navigation Links */}
//         <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//           {navItems.map((item, index) => (
//             <div
//               key={index}
//               className="relative text-gray-700 hover:text-black cursor-pointer flex items-center text-sm font-medium nav-dropdown-container"
//               onClick={() => handleNavDropdownToggle(index)} // Handle click to toggle dropdown
//             >
//               {item.icon && (
//                 <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-black" />
//               )}
//               <span>{item.name}</span>
//               <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />{" "}
//               {/* Removed group-hover */}
//               <div
//                 className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10 ${
//                   openNavDropdown === index ? "block" : "hidden"
//                 }`}
//               >
//                 {item.dropdownItems.map((dItem, dIndex) => (
//                   <a
//                     key={dIndex}
//                     href="#" // You'll want to add actual routes here for each item
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                     onClick={(e) => {
//                       e.stopPropagation(); // Prevent dropdown from closing immediately
//                       // Handle navigation for each dropdown item
//                       // Example: if (dItem === 'Browse Activities') navigate('/activities/browse');
//                     }}
//                   >
//                     {dItem}
//                   </a>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* Right-side Icons */}
//         <div className="flex items-center space-x-4 ml-auto">
//           <div className="relative cursor-pointer text-gray-600 hover:text-black">
//             <BellIcon className="h-6 w-6" />
//             <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//           </div>

//           <div
//             className="relative cursor-pointer text-gray-600 hover:text-black flex items-center user-dropdown-container" // Add a class for click outside detection
//             onClick={handleUserDropdownToggle} // Handle click to toggle dropdown
//           >
//             <UserCircleIcon className="h-7 w-7" />
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />{" "}
//             {/* Removed group-hover */}
//             <div
//               className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10 ${
//                 isUserDropdownOpen ? "block" : "hidden"
//               }`}
//             >
//               {/* My Profile */}
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevent the parent div's onClick from firing again
//                   navigate("/MyPersonalAccount"); // Navigate to my personal account
//                   setIsUserDropdownOpen(false); // Close dropdown after click
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 My Profile
//               </button>
//               {/* Settings (example, you might want to navigate or open a modal) */}
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   // navigate("/settings"); // Example navigation for settings
//                   alert("Settings clicked!"); // For demonstration
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Settings
//               </button>
//               {/* Logout */}
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevent the parent div's onClick from firing again
//                   handleLogout(); // Call the logout function
//                   setIsUserDropdownOpen(false); // Close dropdown after logout
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default UserHeader;
// src/components/Dashboard/UserHeader.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  BellIcon,
  UserCircleIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../Authentication/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";
import {
  FiTag,
  FiUsers,
  FiGift,
} from "react-icons/fi";
import { FaRegCalendar  } from "react-icons/fa";


const Maps_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I"; // Ensure this is your actual API key

const UserHeader = ({ userData }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  // State to manage the visibility of the user dropdown
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  // Stores the index of the open navigation dropdown
  const [openNavDropdown, setOpenNavDropdown] = useState(null);

  // State to manage modal visibility
  const [showLocationModal, setShowLocationModal] = useState(false);
  // State to store the user's selected/entered location
  const [currentLocation, setCurrentLocation] = useState({
    city: "Downtown",
    state: "San Francisco, California",
    latitude: null,
    longitude: null,
  });
  // State for the manual input field in the modal
  const [manualLocationInput, setManualLocationInput] = useState("");
  // State to track if Google Maps API is loaded
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
  // Ref for the manual location input field in the modal to attach autocomplete
  const locationInputModalRef = useRef(null);

  // Variable to hold the Google Places Autocomplete instance
  const autocompleteInstance = useRef(null);

  // Define the initMap callback function using useCallback
  // This is called when the Google Maps script finishes loading.
  const initMap = useCallback(() => {
    setIsGoogleMapsLoaded(true);
  }, []);

  // Load Google Maps API script dynamically and ensure it's loaded only once
  useEffect(() => {
    // Check if the script is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      setIsGoogleMapsLoaded(true);
      return;
    }

    // Assign the initMap function to the global window object BEFORE appending the script
    // This is crucial for the Google Maps API's callback to work.
    window.initMap = initMap;

    // Check if a script with the Google Maps API source already exists
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );

    if (existingScript) {
      // If it exists, but isn't loaded, wait for it to load
      existingScript.onload = () => setIsGoogleMapsLoaded(true);
      existingScript.onerror = () =>
        toast.error("Failed to load Google Maps API.");
      return;
    }

    // If not, create and append the script
    const script = document.createElement("script");
    // We request 'places' and 'geocoding' libraries. 'places' is essential for Autocomplete.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${Maps_API_KEY}&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    script.id = "google-maps-script-header"; // Unique ID for this script

    script.onerror = () => {
      toast.error("Failed to load Google Maps API for location services.");
    };

    document.head.appendChild(script);

    return () => {
      // Clean up the global callback when the component unmounts
      if (window.initMap === initMap) {
        delete window.initMap;
      }
    };
  }, [initMap]); // Depend on initMap (which is stable due to useCallback)

  // Initialize Google Places Autocomplete when modal is open and API is loaded
  useEffect(() => {
    if (
      isGoogleMapsLoaded &&
      showLocationModal &&
      locationInputModalRef.current
    ) {
      // Ensure Autocomplete is only initialized once for this input
      if (!autocompleteInstance.current) {
        try {
          autocompleteInstance.current =
            new window.google.maps.places.Autocomplete(
              locationInputModalRef.current,
              {
                types: ["(cities)"], // Restrict results to cities (or 'geocode' for broader addresses)
                // Removed the country restriction to allow international locations
              }
            );

          autocompleteInstance.current.addListener("place_changed", () => {
            const place = autocompleteInstance.current.getPlace();

            if (place.geometry && place.formatted_address) {
              let city = "Unknown City";
              let state = ""; // Default to empty for state/country
              let latitude = place.geometry.location.lat();
              let longitude = place.geometry.location.lng();

              // Extract city and state/country from address_components
              const addressComponents = place.address_components;
              addressComponents.forEach((component) => {
                if (component.types.includes("locality")) {
                  city = component.long_name;
                } else if (
                  component.types.includes("administrative_area_level_1")
                ) {
                  state = component.long_name;
                } else if (component.types.includes("country")) {
                  // If state is not found, use country as fallback for 'state' field
                  if (!state) {
                    state = component.long_name;
                  }
                }
              });

              setCurrentLocation({
                city: city,
                state: state,
                latitude: latitude,
                longitude: longitude,
              });
              localStorage.setItem(
                "userLocation",
                JSON.stringify({
                  city: city,
                  state: state,
                  latitude: latitude,
                  longitude: longitude,
                })
              );
              setManualLocationInput(place.formatted_address); // Update input field with selected place's full address
              setShowLocationModal(false); // Close modal
              toast.success("Location updated!");
            } else {
              toast.warn("No details available for the selected location.");
              // If no geometry/formatted address, fall back to current input value
              handleManualLocationSubmit(true); // Treat as manual submission
            }
          });
        } catch (error) {
          console.error("Error initializing Google Autocomplete:", error);
          toast.error(
            "Failed to initialize location suggestions. Please try manual entry."
          );
        }
      }
    }

    // Cleanup: Remove listener and destroy autocomplete instance when modal closes or component unmounts
    return () => {
      if (autocompleteInstance.current) {
        if (window.google && window.google.maps && window.google.maps.event) {
          window.google.maps.event.clearInstanceListeners(
            autocompleteInstance.current
          );
        }
        autocompleteInstance.current = null;
      }
    };
  }, [isGoogleMapsLoaded, showLocationModal]); // Re-run when API loads or modal state changes

  // Effect to load location from local storage on component mount
  useEffect(() => {
    const storedLocation = localStorage.getItem("userLocation");
    if (storedLocation) {
      setCurrentLocation(JSON.parse(storedLocation));
    }
  }, []);

  // New useEffect to handle body overflow when modal is open/closed
  useEffect(() => {
    if (showLocationModal) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = ""; // Allow scrolling
    }
    // Cleanup function to ensure overflow is reset if component unmounts while modal is open
    return () => {
      document.body.style.overflow = "";
    };
  }, [showLocationModal]); // Re-run effect whenever showLocationModal changes

  // Function to handle opening the location modal
  const handleLocationClick = () => {
    setShowLocationModal(true);
    setManualLocationInput(""); // Clear manual input when opening modal
  };

  // Function to handle closing the location modal
  const handleCloseModal = () => {
    setShowLocationModal(false);
  };

  // Function to get address details from coordinates using Google Geocoding API
  const getAddressFromCoordinates = async (latitude, longitude) => {
    if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
      toast.error("Google Maps API not fully loaded. Please try again.");
      return null;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: latitude, lng: longitude };

    try {
      const { results } = await geocoder.geocode({ location: latlng });

      if (results && results.length > 0) {
        let city = "Unknown City";
        let state = "Unknown Region";
        let country = "Unknown Country";

        const addressComponents = results[0].address_components;
        addressComponents.forEach((component) => {
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          }
        });

        const displayState = state !== "Unknown Region" ? state : country;

        return {
          city: city,
          state: displayState,
          latitude,
          longitude,
        };
      } else {
        toast.warn("Could not find address details for your current location.");
        return {
          city: "Location Found",
          state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
          latitude,
          longitude,
        };
      }
    } catch (error) {
      console.error("Error reverse geocoding with Google Maps:", error);
      toast.error(
        "Failed to fetch address details. Check console for more info."
      );
      return null;
    }
  };

  // Function to get current geolocation and then reverse geocode it
  const handleUseCurrentLocation = async () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser.");
      return;
    }
    if (!isGoogleMapsLoaded) {
      toast.info("Loading location services... please try again shortly.");
      return;
    }

    toast.info("Fetching your current location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const locationDetails = await getAddressFromCoordinates(
          latitude,
          longitude
        );

        if (locationDetails) {
          setCurrentLocation(locationDetails);
          localStorage.setItem("userLocation", JSON.stringify(locationDetails));
          toast.success("Location updated successfully!");
        } else {
          // Fallback if getAddressFromCoordinates returns null
          setCurrentLocation({
            city: "Unknown Address",
            state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
            latitude,
            longitude,
          });
          localStorage.setItem(
            "userLocation",
            JSON.stringify({
              city: "Unknown Address",
              state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(
                4
              )}`,
              latitude,
              longitude,
            })
          );
        }
        setShowLocationModal(false); // Close modal after fetching
      },
      (error) => {
        let errorMessage = "Unable to retrieve your location.";
        if (error.code === error.PERMISSION_DENIED) {
          errorMessage =
            "Location access denied. Please allow location services in your browser settings.";
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          errorMessage = "Location information is unavailable.";
        } else if (error.code === error.TIMEOUT) {
          errorMessage = "The request to get location timed out.";
        }
        console.error("Geolocation error:", error);
        toast.error(errorMessage);
      }
    );
  };

  // Function to handle manual location submission
  // Added optional parameter to differentiate if called internally (e.g., from autocomplete fallback)
  const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
    if (manualLocationInput.trim() === "") {
      if (!fromAutocompleteFallback) {
        // Only warn if not a fallback from autocomplete
        toast.warn("Please enter a location.");
      }
      return;
    }

    const parts = manualLocationInput.split(",").map((p) => p.trim());
    const city = parts[0] || manualLocationInput.trim();
    const state = parts.length > 1 ? parts.slice(1).join(", ") : "";

    setCurrentLocation({
      city: city,
      state: state,
      latitude: null, // No lat/lng for simple manual entry without geocoding
      longitude: null, // No lat/lng for simple manual entry without geocoding
    });
    localStorage.setItem(
      "userLocation",
      JSON.stringify({
        city: city,
        state: state,
        latitude: null,
        longitude: null,
      })
    );
    setShowLocationModal(false); // Close modal after submission
    if (!fromAutocompleteFallback) {
      // Only show success toast if not a fallback
      toast.success("Manual location set successfully!");
    }
  };

  // Define navigation items and their dropdowns
  // Removed the "Current Location" item from navItems
  const navItems = [
    {
      name: "Activities",
      icon: FiUsers, // No icon for the main "Activities" button
      dropdownItems: [
        { name: "Browse Activities", path: "/LocalActivities" },
        { name: "Create Activity", path: "/PostActivities" },
        { name: "My Activities", path: "/MyActivities" },
        {
          name: "Join Activities",
          path: "/activities/join",
          commingsoon: true,
        },
      ],
    },
    {
      name: "Services",
      icon: FiGift  ,
      dropdownItems: [
        { name: "Browse Services", path: "/services/browse" },
        { name: "Saved Services", path: "/services/saved", commingsoon: true },
        { name: "Favorites", path: "/services/favorites", commingsoon: true },
      ],
    },
    {
      name: "Bookings",
      icon: FaRegCalendar,
      dropdownItems: [
        { name: "Upcoming", path: "/bookings/upcoming", commingsoon: true },
        { name: "History", path: "/bookings/history", commingsoon: true },
        {
          name: "Appointments",
          path: "/bookings/appointments",
          commingsoon: true,
        },
      ],
    },
    {
      name: "Deals",
      icon: FiTag,
      dropdownItems: [
        { name: "Browse Deals", path: "/PopularDeals" }, // Assuming this is for Browse all deals
        { name: "Saved Deals", path: "/deals", commingsoon: true },
        {
          name: "Purchased Deals",
          path: "/deals/purchased",
          commingsoon: true,
        },
        { name: "Purchase History", path: "/deals/history", commingsoon: true },
      ],
    },
  ];

  // Handles user logout
  const handleLogout = () => {
    logout();
    navigate("/"); // Redirect to home/public page after logout
  };

  // Toggles the visibility of the user profile dropdown
  const handleUserDropdownToggle = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
    setOpenNavDropdown(null); // Close any open navigation dropdown when user dropdown is toggled
  };

  // Toggles the visibility of a specific navigation dropdown
  const handleNavDropdownToggle = (index) => {
    setOpenNavDropdown(openNavDropdown === index ? null : index); // Toggle specific nav dropdown
    setIsUserDropdownOpen(false); // Close user dropdown when a nav dropdown is toggled
  };

  // Generic handler for dropdown item clicks (now simpler as filters are internal)
  const handleDropdownItemClick = (item) => {
    if (item.path) {
      navigate(item.path); // Navigate directly to the path
      setOpenNavDropdown(null); // Close the dropdown after navigation
    }
  };

  // Effect to close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the user dropdown
      if (
        isUserDropdownOpen &&
        !event.target.closest(".user-dropdown-container")
      ) {
        setIsUserDropdownOpen(false);
      }
      // Check if the click is outside any nav dropdown
      if (
        openNavDropdown !== null &&
        !event.target.closest(".nav-dropdown-container")
      ) {
        setOpenNavDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUserDropdownOpen, openNavDropdown]); // Dependencies for useEffect

  return (
    <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
  <div className="container mx-auto flex items-center justify-between">
    {/* Logo */}
    <div className="flex-shrink-0 cursor-pointer">
      <img
        src="/upswap.png"
        alt="UpSway Logo"
        className="h-10"
        onClick={() => (window.location.href = "/home")}
      />
    </div>

    {/* Current Location Display (added ml-4 for spacing) */}
    <div
      className="flex items-center cursor-pointer ml-4" // This line was updated
      onClick={handleLocationClick}
    >
      <FaMapMarkerAlt className="text-gray-500 text-base flex-shrink-0 mr-2" />
      <div className="flex flex-col">
        <div className="font-semibold leading-none">
          {currentLocation.city}
        </div>
        <div className="text-xs text-gray-500 leading-none">
          {currentLocation.state}
        </div>
      </div>
    </div>

    {/* Location Modal */}
    {showLocationModal && (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
        <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8">
          {/* Close Icon in top-right corner */}
          <button
            onClick={handleCloseModal}
            className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
            aria-label="Close location selection"
          >
            <FaTimes size={20} />
          </button>

          <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

          {/* Use Current Location Button */}
          <button
            onClick={handleUseCurrentLocation}
            disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
            className={`w-full py-2 px-4 rounded-md transition mb-4 ${
              !isGoogleMapsLoaded
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            <FaMapMarkerAlt className="inline-block mr-2" />
            {isGoogleMapsLoaded ? "Use My Current Location" : "Loading Location Services..."}
          </button>

          <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

          {/* Manual Location Input with Autocomplete */}
          <input
            type="text"
            ref={locationInputModalRef} // Assign ref to this input
            placeholder="Enter location manually (e.g., New York, USA)"
            className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            value={manualLocationInput}
            onChange={(e) => setManualLocationInput(e.target.value)}
          />
          {/* The Set Location button is now primarily for when the user types and doesn't select a suggestion */}
          <button
            onClick={() => handleManualLocationSubmit()} // Call without fallback flag
            className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
          >
            Set Location
          </button>
        </div>
      </div>
    )}

    {/* Navigation Links */}
    <nav className="hidden lg:flex flex-grow justify-center space-x-8">
      {navItems.map((item, index) => (
        <div
          key={index}
          className="relative text-gray-700 hover:text-black font-semibold cursor-pointer flex items-center text-base nav-dropdown-container"
          onClick={() => handleNavDropdownToggle(index)} // Handle click to toggle dropdown
        >
          {item.icon && (
            <item.icon className="h-5 w-5 mr-1 text-gray-600 group-hover:text-black" />
          )}
          <span>{item.name}</span>
          <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />{" "}
          {/* This is the dropdown for navItems */}
          <div
            // Positioning it below the header item
            className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
              openNavDropdown === index ? " flex flex-col gap-2" : "hidden"
            }`}
          >
            {item.dropdownItems.map((dItem, dIndex) => (
              <a
                key={dIndex}
                href={
                  typeof dItem === "object" &&
                  dItem.path &&
                  !dItem.commingsoon
                    ? dItem.path
                    : "#"
                }
                className={`block px-4 py-2 text-sm relative ${
                  dItem.commingsoon
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (dItem.commingsoon) return; // Disable click if coming soon

                  if (typeof dItem === "object") {
                    handleDropdownItemClick(dItem);
                  } else {
                    console.log(`Clicked generic item: ${dItem}`);
                    setOpenNavDropdown(null);
                  }
                }}
              >
                {dItem.commingsoon && (
                  <span className="absolute top-1 left-4 text-xs text-orange-500 font-semibold">
                    Coming Soon
                  </span>
                )}

                <span className={dItem.commingsoon ? "pt-2 block" : ""}>
                  {typeof dItem === "object" ? dItem.name : dItem}
                </span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </nav>

    {/* Right-side Icons */}
    <div className="flex items-center space-x-4 ml-auto">
      <div className="relative cursor-pointer text-gray-600 hover:text-black">
        <BellIcon className="h-6 w-6" />
        <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
      </div>

      <div
        className="relative cursor-pointer text-gray-600 hover:text-black flex items-center user-dropdown-container"
        onClick={handleUserDropdownToggle}
      >
        <UserCircleIcon className="h-7 w-7" />
        <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />{" "}
        {/* User Dropdown */}
        <div
          // Positioning it below the user icon
          className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
            isUserDropdownOpen ? "block" : "hidden"
          }`}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate("/MyPersonalAccount");
              setIsUserDropdownOpen(false);
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            My Profile
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate("/BasicInfo");
              setIsUserDropdownOpen(false);
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            become a vendor
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate("Settings");
              setIsUserDropdownOpen(false);
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Settings
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate("/ContactSupport");
              setIsUserDropdownOpen(false);
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Support
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
              setIsUserDropdownOpen(false);
              localStorage.clear();
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
  );
};

export default UserHeader;












// // src/components/Dashboard/UserHeader.jsx
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   MapPinIcon,
//   BellIcon,
//   UserCircleIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// import { FaTimes } from "react-icons/fa";
// import { useAuth } from "../Authentication/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const GOOGLE_MAPS_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I";

// const UserHeader = ({ userData }) => {
//   const { logout } = useAuth();
//   const navigate = useNavigate();

//   // State management
//   const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
//   const [openNavDropdown, setOpenNavDropdown] = useState(null);
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "New York",
//     state: "New York",
//     latitude: null,
//     longitude: null,
//   });
//   const [manualLocationInput, setManualLocationInput] = useState("");
//   const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

//   // Refs
//   const locationInputModalRef = useRef(null);
//   const autocompleteInstance = useRef(null);

//   // Navigation items
//   const navItems = [
//     {
//       name: "Activities",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Activities", path: "/LocalActivities" },
//         { name: "Create Activity", path: "/PostActivities" },
//         { name: "My Activities", path: "/MyActivities" },
//         { name: "Join Activities", path: "/activities/join", comingsoon: true },
//       ],
//     },
//     {
//       name: "Services",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Services", path: "/services/browse" },
//         { name: "Saved Services", path: "/services/saved", comingsoon: true },
//         { name: "Favorites", path: "/services/favorites", comingsoon: true },
//       ],
//     },
//     {
//       name: "Bookings",
//       icon: null,
//       dropdownItems: [
//         { name: "Upcoming", path: "/bookings/upcoming", comingsoon: true },
//         { name: "History", path: "/bookings/history", comingsoon: true },
//         { name: "Appointments", path: "/bookings/appointments", comingsoon: true },
//       ],
//     },
//     {
//       name: "Deals",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Deals", path: "/ExclusiveDeals" },
//         { name: "Saved Deals", path: "/deals", comingsoon: true },
//         { name: "Purchased Deals", path: "/deals/purchased", comingsoon: true },
//         { name: "Purchase History", path: "/deals/history", comingsoon: true },
//       ],
//     },
//   ];

//   // Initialize Google Maps
//   const initMap = useCallback(() => {
//     setIsGoogleMapsLoaded(true);
//   }, []);

//   // Load Google Maps API
//   useEffect(() => {
//     if (window.google?.maps?.places) {
//       setIsGoogleMapsLoaded(true);
//       return;
//     }

//     window.initMap = initMap;

//     const existingScript = document.querySelector(
//       `script[src*="maps.googleapis.com/maps/api/js"]`
//     );

//     if (existingScript) {
//       existingScript.onload = () => setIsGoogleMapsLoaded(true);
//       existingScript.onerror = () => toast.error("Failed to load Google Maps API.");
//       return;
//     }

//     const script = document.createElement("script");
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     script.id = "google-maps-script-user-header";

//     script.onerror = () => {
//       toast.error("Failed to load Google Maps API for location services.");
//     };

//     document.head.appendChild(script);

//     return () => {
//       if (window.initMap === initMap) {
//         delete window.initMap;
//       }
//     };
//   }, [initMap]);

//   // Initialize Autocomplete
//   useEffect(() => {
//     if (!isGoogleMapsLoaded || !showLocationModal || !locationInputModalRef.current) return;

//     try {
//       autocompleteInstance.current = new window.google.maps.places.Autocomplete(
//         locationInputModalRef.current,
//         { types: ['(cities)'] }
//       );

//       autocompleteInstance.current.addListener("place_changed", () => {
//         const place = autocompleteInstance.current.getPlace();

//         if (place.geometry?.location) {
//           let city = "Unknown City";
//           let state = "";
//           const latitude = place.geometry.location.lat();
//           const longitude = place.geometry.location.lng();

//           place.address_components?.forEach(component => {
//             if (component.types.includes("locality")) {
//               city = component.long_name;
//             } else if (component.types.includes("administrative_area_level_1")) {
//               state = component.long_name;
//             }
//           });

//           const locationData = { city, state, latitude, longitude };
//           setCurrentLocation(locationData);
//           localStorage.setItem("userLocation", JSON.stringify(locationData));
//           setShowLocationModal(false);
//           toast.success("Location updated!");
//         } else {
//           toast.warn("No details available for the selected location.");
//           handleManualLocationSubmit(true);
//         }
//       });
//     } catch (error) {
//       console.error("Error initializing Autocomplete:", error);
//       toast.error("Failed to initialize location suggestions.");
//     }

//     return () => {
//       if (autocompleteInstance.current) {
//         window.google?.maps?.event?.clearInstanceListeners(autocompleteInstance.current);
//         autocompleteInstance.current = null;
//       }
//     };
//   }, [isGoogleMapsLoaded, showLocationModal]);

//   // Load saved location
//   useEffect(() => {
//     const storedLocation = localStorage.getItem("userLocation");
//     if (storedLocation) {
//       setCurrentLocation(JSON.parse(storedLocation));
//     }
//   }, []);

//   // Handle body overflow
//   useEffect(() => {
//     document.body.style.overflow = showLocationModal ? 'hidden' : '';
//     return () => { document.body.style.overflow = ''; };
//   }, [showLocationModal]);

//   // Get address from coordinates
//   const getAddressFromCoordinates = async (latitude, longitude) => {
//     if (!window.google?.maps) {
//       toast.error("Google Maps API not loaded.");
//       return null;
//     }

//     try {
//       const geocoder = new window.google.maps.Geocoder();
//       const { results } = await geocoder.geocode({ location: { lat: latitude, lng: longitude } });

//       if (results?.length > 0) {
//         let city = "Unknown City";
//         let state = "Unknown Region";

//         results[0].address_components?.forEach(component => {
//           if (component.types.includes("locality")) city = component.long_name;
//           if (component.types.includes("administrative_area_level_1")) state = component.long_name;
//         });

//         return { city, state, latitude, longitude };
//       }
//       return {
//         city: "Location Found",
//         state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//         latitude,
//         longitude,
//       };
//     } catch (error) {
//       console.error("Geocoding error:", error);
//       toast.error("Failed to fetch address details.");
//       return null;
//     }
//   };

//   // Handle current location
//   const handleUseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       toast.error("Geolocation not supported.");
//       return;
//     }

//     toast.info("Fetching your location...");

//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const locationDetails = await getAddressFromCoordinates(
//           position.coords.latitude,
//           position.coords.longitude
//         );

//         if (locationDetails) {
//           setCurrentLocation(locationDetails);
//           localStorage.setItem("userLocation", JSON.stringify(locationDetails));
//           toast.success("Location updated!");
//         }
//         setShowLocationModal(false);
//       },
//       (error) => {
//         const errors = {
//           1: "Location access denied.",
//           2: "Location unavailable.",
//           3: "Request timed out."
//         };
//         toast.error(errors[error.code] || "Unable to retrieve location.");
//       }
//     );
//   };

//   // Handle manual location
//   const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
//     if (!manualLocationInput.trim()) {
//       if (!fromAutocompleteFallback) toast.warn("Please enter a location.");
//       return;
//     }

//     const [city, ...stateParts] = manualLocationInput.split(',').map(p => p.trim());
//     const state = stateParts.join(', ');

//     const locationData = { city, state, latitude: null, longitude: null };
//     setCurrentLocation(locationData);
//     localStorage.setItem("userLocation", JSON.stringify(locationData));
//     setShowLocationModal(false);
//     if (!fromAutocompleteFallback) toast.success("Location set!");
//   };

//   // Close modal handler
//   const handleCloseModal = () => {
//     setShowLocationModal(false);
//   };

//   // Event handlers
//   const handleLogout = () => {
//     logout();
//     localStorage.clear();
//     navigate("/");
//   };

//   const handleUserDropdownToggle = () => {
//     setIsUserDropdownOpen(!isUserDropdownOpen);
//     setOpenNavDropdown(null);
//   };

//   const handleNavDropdownToggle = (index) => {
//     setOpenNavDropdown(openNavDropdown === index ? null : index);
//     setIsUserDropdownOpen(false);
//   };

//   const handleDropdownItemClick = (item) => {
//     if (item.path && !item.comingsoon) {
//       navigate(item.path);
//       setOpenNavDropdown(null);
//     }
//   };

//   // Close dropdowns on outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isUserDropdownOpen && !event.target.closest(".user-dropdown-container")) {
//         setIsUserDropdownOpen(false);
//       }
//       if (openNavDropdown !== null && !event.target.closest(".nav-dropdown-container")) {
//         setOpenNavDropdown(null);
//       }
//       if (showLocationModal && !event.target.closest(".location-modal-container")) {
//         setShowLocationModal(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isUserDropdownOpen, openNavDropdown, showLocationModal]);

//   return (
//     <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//       <div className="container mx-auto flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex-shrink-0 cursor-pointer">
//           <img
//             src="/upswap.png"
//             alt="UpSway Logo"
//             className="h-10"
//             onClick={() => navigate("/home")}
//           />
//         </div>

//         {/* Navigation Links */}
//         <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//           {/* Location */}
//           <div
//             className="relative text-gray-700 hover:text-black cursor-pointer flex items-center text-sm font-medium"
//             onClick={() => {
//               setShowLocationModal(true);
//               setOpenNavDropdown(null);
//               setIsUserDropdownOpen(false);
//               setManualLocationInput(
//                 currentLocation.city +
//                 (currentLocation.state ? `, ${currentLocation.state}` : '')
//               );
//             }}
//           >
//             <MapPinIcon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-black" />
//             <span>{currentLocation.city}</span>
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//           </div>

//           {/* Navigation Items */}
//           {navItems.map((item, index) => (
//             <div
//               key={index}
//               className="relative text-gray-700 hover:text-black cursor-pointer flex items-center text-sm font-medium nav-dropdown-container"
//               onClick={() => handleNavDropdownToggle(index)}
//             >
//               {item.icon && (
//                 <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-black" />
//               )}
//               <span>{item.name}</span>
//               <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//               <div
//                 className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                   openNavDropdown === index ? "flex flex-col gap-2" : "hidden"
//                 }`}
//               >
//                 {item.dropdownItems.map((dItem, dIndex) => (
//                   <button
//                     key={dIndex}
//                     className={`block px-4 py-2 text-sm text-left relative ${
//                       dItem.comingsoon
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "text-gray-700 hover:bg-gray-100"
//                     }`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleDropdownItemClick(dItem);
//                     }}
//                   >
//                     {dItem.comingsoon && (
//                       <span className="absolute top-1 left-4 text-xs text-orange-500 font-semibold">
//                         Coming Soon
//                       </span>
//                     )}
//                     <span className={dItem.comingsoon ? "pt-2 block" : ""}>
//                       {dItem.name}
//                     </span>
//                   </button>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* Right-side Icons */}
//         <div className="flex items-center space-x-4 ml-auto">
//           <div className="relative cursor-pointer text-gray-600 hover:text-black">
//             <BellIcon className="h-6 w-6" />
//             <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//           </div>

//           <div
//             className="relative cursor-pointer text-gray-600 hover:text-black flex items-center user-dropdown-container"
//             onClick={handleUserDropdownToggle}
//           >
//             <UserCircleIcon className="h-7 w-7" />
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//             <div
//               className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                 isUserDropdownOpen ? "block" : "hidden"
//               }`}
//             >
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/MyPersonalAccount");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 My Profile
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/BasicInfo");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Become a Vendor
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/Settings");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Settings
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/ContactSupport");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Support
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleLogout();
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Location Modal */}
//       {showLocationModal && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
//           <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8 location-modal-container">
//             <button
//               onClick={handleCloseModal}
//               className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700"
//               aria-label="Close"
//             >
//               <FaTimes size={20} />
//             </button>

//             <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

//             <button
//               onClick={handleUseCurrentLocation}
//               disabled={!isGoogleMapsLoaded}
//               className={`w-full py-2 px-4 rounded-md transition mb-4 ${
//                 !isGoogleMapsLoaded
//                   ? "bg-blue-300 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               <MapPinIcon className="inline-block mr-2 w-5 h-5" />
//               {isGoogleMapsLoaded ? "Use Current Location" : "Loading..."}
//             </button>

//             <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

//             <input
//               type="text"
//               ref={locationInputModalRef}
//               placeholder="Enter location (e.g., New Delhi, India)"
//               className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
//               value={manualLocationInput}
//               onChange={(e) => setManualLocationInput(e.target.value)}
//             />

//             <button
//               onClick={() => handleManualLocationSubmit()}
//               className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition"
//             >
//               Set Location
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default UserHeader;

// // src/components/Dashboard/UserHeader.jsx
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   MapPinIcon,
//   BellIcon,
//   UserCircleIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// import { FaTimes } from "react-icons/fa";
// import { useAuth } from "../Authentication/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const GOOGLE_MAPS_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I";

// const UserHeader = ({ userData }) => {
//   const { logout } = useAuth();
//   const navigate = useNavigate();

//   const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
//   const [openNavDropdown, setOpenNavDropdown] = useState(null);
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "New York",
//     state: "New York",
//     latitude: null,
//     longitude: null,
//   });
//   const [manualLocationInput, setManualLocationInput] = useState("");
//   const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
//   const [isAutocompleteInitializing, setIsAutocompleteInitializing] = useState(false);
//   const locationInputModalRef = useRef(null);
//   const autocompleteInstance = useRef(null);

//   const navItems = [
//     {
//       name: "Activities",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Activities", path: "/LocalActivities" },
//         { name: "Create Activity", path: "/PostActivities" },
//         { name: "My Activities", path: "/MyActivities" },
//         { name: "Join Activities", path: "/activities/join", commingsoon: true },
//       ],
//     },
//     {
//       name: "Services",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Services", path: "/services/browse" },
//         { name: "Saved Services", path: "/services/saved", commingsoon: true },
//         { name: "Favorites", path: "/services/favorites", commingsoon: true },
//       ],
//     },
//     {
//       name: "Bookings",
//       icon: null,
//       dropdownItems: [
//         { name: "Upcoming", path: "/bookings/upcoming", commingsoon: true },
//         { name: "History", path: "/bookings/history", commingsoon: true },
//         { name: "Appointments", path: "/bookings/appointments", commingsoon: true },
//       ],
//     },
//     {
//       name: "Deals",
//       icon: null,
//       dropdownItems: [
//         { name: "Browse Deals", path: "/PopularDeals" },
//         { name: "Saved Deals", path: "/deals", commingsoon: true },
//         { name: "Purchased Deals", path: "/deals/purchased", commingsoon: true },
//         { name: "Purchase History", path: "/deals/history", commingsoon: true },
//       ],
//     },
//   ];

//   const initMap = useCallback(() => {
//     console.log("Google Maps API script loaded successfully.");
//     setIsGoogleMapsLoaded(true);
//   }, []);

//   useEffect(() => {
//     console.log("Google Maps API script loading effect ran.");
//     if (window.google && window.google.maps && window.google.maps.places) {
//       console.log("Google Maps API already loaded.");
//       setIsGoogleMapsLoaded(true);
//       return;
//     }

//     window.initMap = initMap;

//     const existingScript = document.querySelector(
//       `script[src*="maps.googleapis.com/maps/api/js"]`
//     );

//     if (existingScript) {
//       console.log("Existing Google Maps script found.");
//       existingScript.onload = () => {
//         setIsGoogleMapsLoaded(true);
//         console.log("Existing Google Maps script loaded successfully.");
//       };
//       existingScript.onerror = () => {
//         toast.error("Failed to load Google Maps API.");
//         console.error("Existing Google Maps script failed to load.");
//       };
//       return;
//     }

//     const script = document.createElement("script");
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     script.id = "google-maps-script-user-header";

//     script.onerror = () => {
//       toast.error("Failed to load Google Maps API for location services.");
//       console.error("New Google Maps script failed to load.");
//     };

//     document.head.appendChild(script);
//     console.log("Google Maps script appended to head.");

//     return () => {
//       if (window.initMap === initMap) {
//         delete window.initMap;
//         console.log("Cleaned up window.initMap.");
//       }
//     };
//   }, [initMap]);

//   useEffect(() => {
//     console.log(
//       "Autocomplete effect ran. isGoogleMapsLoaded:",
//       isGoogleMapsLoaded,
//       "showLocationModal:",
//       showLocationModal,
//       "locationInputModalRef.current:",
//       !!locationInputModalRef.current
//     );

//     if (isGoogleMapsLoaded && showLocationModal && locationInputModalRef.current) {
//       if (!autocompleteInstance.current) {
//         console.log("Initializing Google Autocomplete...");
//         setIsAutocompleteInitializing(true);

//         try {
//           if (!window.google || !window.google.maps || !window.google.maps.places) {
//             throw new Error("Google Maps Places API not properly loaded");
//           }

//           autocompleteInstance.current = new window.google.maps.places.Autocomplete(
//             locationInputModalRef.current,
//             {
//               types: ["(cities)"],
//               fields: ["address_components", "geometry", "formatted_address"]
//             }
//           );

//           autocompleteInstance.current.addListener("place_changed", () => {
//             const place = autocompleteInstance.current.getPlace();
//             console.log("Autocomplete: place_changed event fired. Place:", place);

//             if (!place || !place.geometry) {
//               console.warn("No geometry found in place object");
//               toast.warn("Could not find precise location details. Please try another selection or enter manually.");
//               return;
//             }

//             try {
//               let city = "Unknown City";
//               let state = "";
//               let latitude = place.geometry.location.lat();
//               let longitude = place.geometry.location.lng();

//               if (place.address_components) {
//                 for (const component of place.address_components) {
//                   if (component.types.includes("locality")) {
//                     city = component.long_name;
//                   } else if (component.types.includes("administrative_area_level_1")) {
//                     state = component.long_name;
//                   } else if (component.types.includes("country") && !state) {
//                     state = component.long_name;
//                   }
//                 }
//               }

//               const newLocationData = {
//                 city: city || place.name || "Selected Location",
//                 state,
//                 latitude,
//                 longitude
//               };

//               setCurrentLocation(newLocationData);
//               localStorage.setItem("userLocation", JSON.stringify(newLocationData));
//               setManualLocationInput(place.formatted_address || `${city}${state ? `, ${state}` : ''}`);
//               setShowLocationModal(false);
//               toast.success(`Location set to: ${newLocationData.city}${newLocationData.state ? `, ${newLocationData.state}` : ''}`);
//             } catch (error) {
//               console.error("Error processing selected place:", error);
//               toast.error("Error processing location selection. Please try again.");
//             }
//           });
//         } catch (error) {
//           console.error("Error initializing Google Autocomplete:", error);
//           toast.error(
//             "Failed to initialize location suggestions. Please refresh the page and try again."
//           );
//           const script = document.querySelector('#google-maps-script-user-header');
//           if (script) {
//             script.parentNode.removeChild(script);
//             setIsGoogleMapsLoaded(false);
//           }
//         } finally {
//           setIsAutocompleteInitializing(false);
//         }
//       }
//     }

//     return () => {
//       if (autocompleteInstance.current) {
//         console.log("Cleaning up Autocomplete instance.");
//         if (window.google && window.google.maps && window.google.maps.event) {
//           window.google.maps.event.clearInstanceListeners(
//             autocompleteInstance.current
//           );
//         }
//         autocompleteInstance.current = null;
//       }
//     };
//   }, [isGoogleMapsLoaded, showLocationModal]);

//   useEffect(() => {
//     const storedLocation = localStorage.getItem("userLocation");
//     if (storedLocation) {
//       try {
//         const parsedLocation = JSON.parse(storedLocation);
//         setCurrentLocation(parsedLocation);
//         console.log("Loaded location from localStorage:", parsedLocation);
//         setManualLocationInput(
//           parsedLocation.city +
//             (parsedLocation.state ? `, ${parsedLocation.state}` : "")
//         );
//       } catch (e) {
//         console.error("Error parsing stored location from localStorage:", e);
//         localStorage.removeItem("userLocation");
//         setCurrentLocation({
//           city: "New York",
//           state: "New York",
//           latitude: null,
//           longitude: null,
//         });
//         setManualLocationInput("New York, New York");
//       }
//     } else {
//       console.log("No location found in localStorage. Using default.");
//     }
//   }, []);

//   useEffect(() => {
//     console.log("currentLocation state updated:", currentLocation);
//   }, [currentLocation]);

//   useEffect(() => {
//     if (showLocationModal) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [showLocationModal]);

//   const getAddressFromCoordinates = async (latitude, longitude) => {
//     if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
//       toast.error("Google Maps API not fully loaded. Please try again.");
//       console.error("Geocoding failed: Google Maps API not loaded.");
//       return null;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     const latlng = { lat: latitude, lng: longitude };
//     console.log("Geocoding coordinates:", latlng);

//     try {
//       const { results } = await geocoder.geocode({ location: latlng });
//       console.log("Geocoding results:", results);

//       if (results && results.length > 0) {
//         let city = "Unknown City";
//         let state = "Unknown Region";
//         let country = "Unknown Country";

//         const addressComponents = results[0].address_components;
//         addressComponents.forEach((component) => {
//           if (component.types.includes("locality")) {
//             city = component.long_name;
//           } else if (component.types.includes("administrative_area_level_1")) {
//             state = component.long_name;
//           } else if (component.types.includes("country")) {
//             country = component.long_name;
//           }
//         });

//         const displayState = state !== "Unknown Region" ? state : country;
//         const resolvedLocation = {
//           city,
//           state: displayState,
//           latitude,
//           longitude,
//         };
//         console.log("Geocoded address:", resolvedLocation);
//         return resolvedLocation;
//       } else {
//         toast.warn("Could not find address details for your current location.");
//         console.log("No geocoding results found.");
//         return {
//           city: "Location Found",
//           state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//           latitude,
//           longitude,
//         };
//       }
//     } catch (error) {
//       console.error("Error reverse geocoding with Google Maps:", error);
//       toast.error(
//         "Failed to fetch address details. Check console for more info."
//       );
//       return null;
//     }
//   };

//   const handleUseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       toast.error("Geolocation is not supported by your browser.");
//       console.warn("Geolocation not supported.");
//       return;
//     }
//     if (!isGoogleMapsLoaded) {
//       toast.info("Loading location services... please try again shortly.");
//       console.log("handleUseCurrentLocation: Google Maps not yet loaded.");
//       return;
//     }

//     toast.info("Fetching your current location...");
//     console.log("Attempting to get current geolocation...");

//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         console.log("Geolocation obtained:", { latitude, longitude });
//         const locationDetails = await getAddressFromCoordinates(
//           latitude,
//           longitude
//         );

//         if (locationDetails) {
//           setCurrentLocation(locationDetails);
//           localStorage.setItem("userLocation", JSON.stringify(locationDetails));
//           toast.success("Location updated successfully!");
//           console.log(
//             "Location updated from current geolocation:",
//             locationDetails
//           );
//         } else {
//           const fallbackLocation = {
//             city: "Unknown Address",
//             state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//             latitude,
//             longitude,
//           };
//           setCurrentLocation(fallbackLocation);
//           localStorage.setItem(
//             "userLocation",
//             JSON.stringify(fallbackLocation)
//           );
//           console.log(
//             "Fallback location set from current geolocation:",
//             fallbackLocation
//           );
//         }
//         setShowLocationModal(false);
//       },
//       (error) => {
//         let errorMessage = "Unable to retrieve your location.";
//         if (error.code === error.PERMISSION_DENIED) {
//           errorMessage =
//             "Location access denied. Please allow location services in your browser settings.";
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           errorMessage = "Location information is unavailable.";
//         } else if (error.code === error.TIMEOUT) {
//           errorMessage = "The request to get location timed out.";
//         }
//         console.error("Geolocation error:", error);
//         toast.error(errorMessage);
//       }
//     );
//   };

//   const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
//     console.log(
//       "handleManualLocationSubmit called. manualLocationInput:",
//       manualLocationInput
//     );

//     if (manualLocationInput.trim() === "") {
//       if (!fromAutocompleteFallback) {
//         toast.warn("Please enter a location.");
//       }
//       return;
//     }

//     const parts = manualLocationInput.split(",").map((p) => p.trim());
//     const city = parts[0] || manualLocationInput.trim();
//     const state = parts.length > 1 ? parts.slice(1).join(", ") : "";

//     const locationData = { city, state, latitude: null, longitude: null };
//     setCurrentLocation(locationData);
//     localStorage.setItem("userLocation", JSON.stringify(locationData));
//     setShowLocationModal(false);
//     if (!fromAutocompleteFallback) {
//       toast.success(`Location set to: ${city}${state ? `, ${state}` : ''}`);
//     }
//     console.log("Manual location set:", locationData);
//   };

//   const handleLogout = () => {
//     logout();
//     localStorage.clear();
//     navigate("/");
//   };

//   const handleUserDropdownToggle = () => {
//     setIsUserDropdownOpen(!isUserDropdownOpen);
//     setOpenNavDropdown(null);
//   };

//   const handleNavDropdownToggle = (index) => {
//     setOpenNavDropdown(openNavDropdown === index ? null : index);
//     setIsUserDropdownOpen(false);
//   };

//   const handleDropdownItemClick = (item) => {
//     if (item.path && !item.commingsoon) {
//       navigate(item.path);
//       setOpenNavDropdown(null);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowLocationModal(false);
//     console.log("Location modal closed.");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isUserDropdownOpen && !event.target.closest(".user-dropdown-container")) {
//         setIsUserDropdownOpen(false);
//       }
//       if (openNavDropdown !== null && !event.target.closest(".nav-dropdown-container")) {
//         setOpenNavDropdown(null);
//       }
//       if (showLocationModal && !event.target.closest(".location-modal-container")) {
//         setShowLocationModal(false);
//         console.log("Location modal closed by outside click.");
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isUserDropdownOpen, openNavDropdown, showLocationModal]);

//   return (
//     <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//       <div className="container mx-auto flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex-shrink-0 cursor-pointer">
//           <img
//             src="/upswap.png"
//             alt="UpSway Logo"
//             className="h-10"
//             onClick={() => (window.location.href = "/home")}
//           />
//         </div>

//         {/* Navigation Links */}
//         <nav className="hidden lg:flex flex-grow justify-center space-x-8">
//           {/* Current Location */}
//           <div
//             className="relative text-gray-700 hover:text-black cursor-pointer flex items-center text-sm font-medium"
//             onClick={() => {
//               setShowLocationModal(true);
//               setOpenNavDropdown(null);
//               setIsUserDropdownOpen(false);
//               setManualLocationInput(
//                 currentLocation.city +
//                   (currentLocation.state ? `, ${currentLocation.state}` : "")
//               );
//               console.log("Location header clicked. Opening modal.");
//             }}
//           >
//             <MapPinIcon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-black" />
//             <div className="flex flex-col">
//               <div className="font-semibold leading-none">
//                 {currentLocation.city}
//               </div>
//               <div className="text-xs text-gray-500 leading-none">
//                 {currentLocation.state}
//               </div>
//             </div>
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//           </div>

//           {navItems.map((item, index) => (
//             <div
//               key={index}
//               className="relative text-gray-700 hover:text-black cursor-pointer flex items-center text-sm font-medium nav-dropdown-container"
//               onClick={() => handleNavDropdownToggle(index)}
//             >
//               {item.icon && (
//                 <item.icon className="h-5 w-5 mr-1 text-gray-500 group-hover:text-black" />
//               )}
//               <span>{item.name}</span>
//               <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//               <div
//                 className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                   openNavDropdown === index ? " flex flex-col gap-2" : "hidden"
//                 }`}
//               >
//                 {item.dropdownItems.map((dItem, dIndex) => (
//                   <button
//                     key={dIndex}
//                     className={`block px-4 py-2 text-sm text-left relative ${
//                       dItem.commingsoon
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "text-gray-700 hover:bg-gray-100"
//                     }`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleDropdownItemClick(dItem);
//                     }}
//                   >
//                     {dItem.commingsoon && (
//                       <span className="absolute top-1 left-4 text-xs text-orange-500 font-semibold">
//                         Coming Soon
//                       </span>
//                     )}
//                     <span className={dItem.commingsoon ? "pt-2 block" : ""}>
//                       {dItem.name}
//                     </span>
//                   </button>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* Right-side Icons */}
//         <div className="flex items-center space-x-4 ml-auto">
//           <div className="relative cursor-pointer text-gray-600 hover:text-black">
//             <BellIcon className="h-6 w-6" />
//             <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
//           </div>

//           <div
//             className="relative cursor-pointer text-gray-600 hover:text-black flex items-center user-dropdown-container"
//             onClick={handleUserDropdownToggle}
//           >
//             <UserCircleIcon className="h-7 w-7" />
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />
//             <div
//               className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                 isUserDropdownOpen ? "block" : "hidden"
//               }`}
//             >
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/MyPersonalAccount");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 My Profile
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/BasicInfo");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Become a Vendor
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/Settings");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Settings
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   navigate("/ContactSupport");
//                   setIsUserDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Support
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleLogout();
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Location Modal */}
//       {showLocationModal && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
//           <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8 location-modal-container">
//             <button
//               onClick={handleCloseModal}
//               className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700"
//               aria-label="Close"
//             >
//               <FaTimes size={20} />
//             </button>

//             <h2 className="text-xl font-bold mb-4 text-gray-800">
//               Select Your Location
//             </h2>

//             {!isGoogleMapsLoaded && (
//               <div className="text-sm text-gray-500 mb-2">
//                 Loading location services...
//               </div>
//             )}

//             <button
//               onClick={handleUseCurrentLocation}
//               disabled={!isGoogleMapsLoaded}
//               className={`w-full py-2 px-4 rounded-md transition mb-4 ${
//                 !isGoogleMapsLoaded
//                   ? "bg-blue-300 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               <MapPinIcon className="inline-block mr-2 w-5 h-5" />
//               {isGoogleMapsLoaded ? "Use Current Location" : "Loading..."}
//             </button>

//             <div className="text-center text-gray-500 mb-4 font-semibold cursor-pointer">
//               - OR -
//             </div>

//             <input
//               type="text"
//               ref={locationInputModalRef}
//               placeholder="Enter location (e.g., New Delhi, India)"
//               className="w-full border cursor-pointer border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
//               value={manualLocationInput}
//               onChange={(e) => {
//                 setManualLocationInput(e.target.value);
//                 if (autocompleteInstance.current) {
//                   window.google.maps.event.clearInstanceListeners(autocompleteInstance.current);
//                   autocompleteInstance.current = null;
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   handleManualLocationSubmit();
//                 }
//               }}
//             />

//             {isAutocompleteInitializing && (
//               <div className="text-sm text-gray-500 mb-2">
//                 Loading location suggestions...
//               </div>
//             )}

//             <button
//               onClick={() => handleManualLocationSubmit()}
//               className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition"
//             >
//               Set Location
//             </button>

//             <div className="mt-4 text-xs text-gray-500">
//               {isGoogleMapsLoaded && !isAutocompleteInitializing && !autocompleteInstance.current && (
//                 <p>Having trouble with suggestions? Try entering manually and clicking Set Location.</p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default UserHeader;
